import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { submitKafalaDemande } from '../services/kafalaService';
import './KafalaDemandeForm.css';

const AGE_VALUES = ['under_5', '5_10', '10_15', 'over_15', 'any'];
const GENDER_VALUES = ['any', 'M', 'F'];
const PAYMENT_VALUES = ['bank', 'cash', 'check', 'whatsapp'];
const FREQ_VALUES = ['monthly', 'quarterly', 'yearly', 'once'];

const emptyForm = {
  nombre_orphelins: '1',
  age_preference: 'under_5',
  gender_preference: 'any',
  payment_method: '',
  payment_frequency: '',
  full_name: '',
  phone: '',
  email: '',
  address: '',
};

const KafalaDemandeForm = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess(false);
    if (!form.payment_method || !form.payment_frequency) {
      setError(t('kafalaForm.choosePayment'));
      return;
    }
    setSaving(true);
    try {
      await submitKafalaDemande({
        ...form,
        nombre_orphelins: Number(form.nombre_orphelins),
      });
      setForm(emptyForm);
      setSuccess(true);
    } catch (err) {
      const data = err.response?.data;
      setError(data?.message || t('kafalaForm.sendError'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <section id="request" className="program-section kafala-demande">
      <div className="program-section__inner kafala-demande__inner">
        <h2 className="kafala-demande__title">{t('kafalaForm.title')}</h2>
        <form onSubmit={onSubmit} className="kafala-demande__form">
          <fieldset>
            <legend>{t('kafalaForm.step1')}</legend>
            <label>
              {t('kafalaForm.orphanCount')}
              <select name="nombre_orphelins" value={form.nombre_orphelins} onChange={onChange}>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
              </select>
            </label>
            <label>
              {t('kafalaForm.age')}
              <select name="age_preference" value={form.age_preference} onChange={onChange}>
                {AGE_VALUES.map((value) => (
                  <option key={value} value={value}>
                    {t(`kafalaForm.age_${value}`)}
                  </option>
                ))}
              </select>
            </label>
            <label>
              {t('kafalaForm.gender')}
              <select name="gender_preference" value={form.gender_preference} onChange={onChange}>
                {GENDER_VALUES.map((value) => (
                  <option key={value} value={value}>
                    {t(`kafalaForm.gender_${value}`)}
                  </option>
                ))}
              </select>
            </label>
          </fieldset>

          <fieldset>
            <legend>{t('kafalaForm.step2')}</legend>
            <label>
              {t('kafalaForm.paymentMethod')}
              <select name="payment_method" value={form.payment_method} onChange={onChange} required>
                <option value="">{t('kafalaForm.chooseOption')}</option>
                {PAYMENT_VALUES.map((value) => (
                  <option key={value} value={value}>
                    {t(`kafalaForm.pay_${value}`)}
                  </option>
                ))}
              </select>
            </label>
            <label>
              {t('kafalaForm.paymentFrequency')}
              <select name="payment_frequency" value={form.payment_frequency} onChange={onChange} required>
                <option value="">{t('kafalaForm.chooseOption')}</option>
                {FREQ_VALUES.map((value) => (
                  <option key={value} value={value}>
                    {t(`kafalaForm.freq_${value}`)}
                  </option>
                ))}
              </select>
            </label>
          </fieldset>

          <fieldset>
            <legend>{t('kafalaForm.step3')}</legend>
            <label>
              {t('kafalaForm.fullName')}
              <input name="full_name" value={form.full_name} onChange={onChange} required />
            </label>
            <label>
              {t('kafalaForm.phone')}
              <input name="phone" value={form.phone} onChange={onChange} required />
            </label>
            <label>
              {t('kafalaForm.email')}
              <input type="email" name="email" value={form.email} onChange={onChange} />
            </label>
            <label>
              {t('kafalaForm.address')}
              <input name="address" value={form.address} onChange={onChange} />
            </label>
          </fieldset>

          {error && <p className="kafala-demande__error">{error}</p>}
          {success && <p className="kafala-demande__success">{t('kafalaForm.success')}</p>}

          <button type="submit" disabled={saving}>
            {saving ? t('kafalaForm.sending') : t('kafalaForm.submit')}
          </button>
        </form>
      </div>
    </section>
  );
};

export default KafalaDemandeForm;
